import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { dataGridModel, queryClient as qc } from 'keys';
import { assessmentsHooks, TableToolbar } from '.';
import { initialPage } from 'keys/pagination';
import { Table } from 'components';
import { WrapDataGrid } from 'components/DataGrid/Style';
import { map } from 'lodash';
import { AssessmentsContext } from './AssessmentsContext';
import { DoughnutCharts } from '.'
import AssessmentFiltersHeader from './AssessmentFiltersHeader';

const AssessmentsC = () => {
    const { pageSize, setPageSize, refetchTableData, refetchChartData, assessmentOptions, sorting, setSorting, searchVal, setSearchVal, viewTypes, viewScreen, assessments, assessmentFilters, setAssessmentFilters, page, setPage } = useContext(AssessmentsContext)
    const { headerFilters } = useSelector(state => state.header)

    const headerItems = assessmentsHooks.useHeaderItems()
    const columns = assessmentsHooks.useColumns()

    useEffect(() => {
        setPage(initialPage)
    }, [headerFilters])

    return (
        <WrapDataGrid overflow={viewScreen == viewTypes.chart}>
            <AssessmentFiltersHeader
                refetchData={viewScreen == viewTypes.table ? refetchTableData : refetchChartData}
                headerItems={[...map(headerItems)]}
                loading={assessments.isFetching}
                assessmentFilters={assessmentFilters}
                setAssessmentFilters={setAssessmentFilters}
            />
            {viewScreen == viewTypes.table ?
                <Table
                    withTitle
                    loading={assessments.isFetching && !assessments.data}
                    data={assessments.data}
                    columns={columns}
                    page={page}
                    setPage={setPage}
                    visibilityModelKey={dataGridModel.assessments}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    queryKey={assessmentOptions.queryKey}
                    customToolbar={<TableToolbar />}
                /> :
                <DoughnutCharts assessmentFilters={assessmentFilters} />
            }
        </WrapDataGrid>
    );
}

export default AssessmentsC
